export const DOCUMENTS_LIST_UPDATE = 'DOCUMENTS_LIST_UPDATE'

export const DOCUMENT_LOAD_TO_STATE = 'DOCUMENT_LOAD_TO_STATE'
export const DOCUMENT_UPDATE_FIELDS = 'DOCUMENT_UPDATE_FIELDS'
export const DOCUMENT_REMOVE_FROM_STATE = 'NEW_DOCUMENT_REMOVE_FROM_STATE'
